import PropTypes from "prop-types";
import { createContext, useEffect, useReducer } from "react";

import jwtDecode from "jwt-decode";

import { LOGIN, LOGOUT } from "store/reducers/actions";
import authReducer from "store/reducers/auth";

import axios from "utils/axios";
import Loader from "components/Loader";

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
};

const verifyToken = (token) => {
  if (!token) {
    return false;
  }
  const decoded = jwtDecode(token);
  return decoded.exp > Date.now() / 1000;
};

const setSession = (token) => {
  if (token) {
    localStorage.setItem("token", token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common.Authorization;
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const init = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token && verifyToken(token)) {
          setSession(token);
          const response = await axios.get("/users/profile/");
          const { user } = response.data;
          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              user,
            },
          });
        } else {
          // setSession(null);
          dispatch({
            type: LOGOUT,
          });
        }
      } catch (err) {
        // setSession(null);
        dispatch({ type: LOGOUT });
      }
    };
    init();
  }, []);

  const login = async (auth_field, password) => {
    const response = await axios.post("/login/", { auth_field, password });
    const { tokens, user } = response.data;
    const token = tokens.access;
    setSession(token);
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user,
      },
    });
  };

  const signup = async (
    first_name,
    last_name,
    username,
    email,
    phone_number,
    company_name,
    company_email,
    password
  ) => {
    const response = await axios.post("/frontend_registration/", {
      first_name,
      last_name,
      username,
      email,
      phone_number,
      company_name,
      company_email,
      password,
    });
    const { tokens, user } = response.data;
    const token = tokens.access;
    setSession(token);
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user,
      },
    });
    return response;
  };

  const logout = () => {
    setSession(null);
    dispatch({ type: LOGOUT });
  };

  const resetPassword = async () => {};

  const updateProfile = () => {};

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  return (
    <JWTContext.Provider
      value={{
        ...state,
        login,
        signup,
        logout,
        resetPassword,
        updateProfile,
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

JWTProvider.propTypes = {
  children: PropTypes.node,
};

export default JWTContext;
